module.exports = __webpack_public_path__ + "img/x-circle-fill.7bb7c194.svg";